import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';

import { FooterOverlay, Membership } from '../../components';
import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    <Membership />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">One Golden Palace Lane, Debonair, XA.</p>
        <p className="p__opensans">+1 555-555-0101</p>
        </div>

      <div className="app__footer-links_logo">
        <img src={images.regal} alt="footer_logo" />
        <p className="p__opensans">&quot;Top tier dining for the elite.&quot;</p>
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Hours of Operation</h1>
        <p className="p__opensans">Wednesday - Sunday:</p>
        <p className="p__opensans">1700hrs - 2330hrs</p>
        </div>
    </div>

   

  </div>
);

export default Footer;